import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "h4 title fw-normal mb-72 text-primary" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "form mb-48" }
const _hoisted_5 = { class: "row gx-32" }
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = { class: "col-3" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = { class: "form-actions text-end" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-user-add-alt fw-bold me-8" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_form_group_input_text = _resolveComponent("v-form-group-input-text")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_form_group_select = _resolveComponent("v-form-group-select")!
  const _component_v_button = _resolveComponent("v-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: "container auth-container",
    onKeypress: _cache[5] || (_cache[5] = _withKeys(_withModifiers(($event: any) => (_ctx.meta.valid ? _ctx.createClinic() : null), ["prevent"]), ["enter"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.$t('Añadir')) + " ", 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('nueva clínica')), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_form_group_input_text, {
              label: _ctx.$t('Nombre'),
              value: _ctx.name,
              class: "mb-24",
              "yup-errors-variable": _ctx.errors.name,
              autocomplete: "off",
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.name = $event))
            }, null, 8, ["label", "value", "yup-errors-variable"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_v_form_group_select, {
              label: _ctx.$t('Prefijo tel.'),
              class: "mb-24",
              "yup-errors-variable": _ctx.errors.phoneNumberPrefix
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  class: _normalizeClass({'is-invalid': !!_ctx.errors.phoneNumberPrefix}),
                  options: _ctx.formsSettings.valid_phone_number_prefix_options,
                  reduce: returnValue => returnValue.key,
                  "select-on-key-codes": [188, 13],
                  modelValue: _ctx.phoneNumberPrefix,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phoneNumberPrefix) = $event))
                }, {
                  "no-options": _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('No se han encontrado resultados')), 1)
                  ]),
                  _: 1
                }, 8, ["class", "options", "reduce", "modelValue"])
              ]),
              _: 1
            }, 8, ["label", "yup-errors-variable"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_v_form_group_input_text, {
              label: _ctx.$t('Teléfono'),
              type: "number",
              value: _ctx.phoneNumber,
              class: "mb-24",
              "yup-errors-variable": _ctx.errors.phoneNumber,
              autocomplete: "off",
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.phoneNumber = $event))
            }, null, 8, ["label", "value", "yup-errors-variable"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_form_group_input_text, {
              label: _ctx.$t('Dirección'),
              value: _ctx.address,
              class: "mb-24",
              "yup-errors-variable": _ctx.errors.address,
              autocomplete: "off",
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.address = $event))
            }, null, 8, ["label", "value", "yup-errors-variable"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_v_button, {
          variant: "link-secondary",
          class: "me-24",
          "aria-label": _ctx.$t('Cancelar'),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.go(-1)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Cancelar')), 1)
          ]),
          _: 1
        }, 8, ["aria-label"]),
        _createVNode(_component_v_button, {
          variant: "secondary",
          class: "btn-icon",
          "aria-label": _ctx.$t('Añadir'),
          disabled: !_ctx.meta.valid || _ctx.accepted,
          onClick: _ctx.createClinic,
          "is-loading": _ctx.accepted
        }, {
          default: _withCtx(() => [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('Dar de alta')), 1)
          ]),
          _: 1
        }, 8, ["aria-label", "disabled", "onClick", "is-loading"])
      ])
    ])
  ], 32))
}